var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.375 0H21.625H17.875C14.2568 0 11.25 2.94431 11.25 6.5625C11.25 9.863 13.7616 12.6023 16.9375 13.0582V15.9375C16.9375 16.3165 17.1654 16.6589 17.5161 16.8036C17.8619 16.9479 18.2676 16.8705 18.5379 16.6003L21.625 13.5132L22.0132 13.125H25.375C28.9932 13.125 32 10.1807 32 6.5625C32 2.94431 28.9932 0 25.375 0Z",
    fill: "#FFBA11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.375 13.125C28.9932 13.125 32 10.1807 32 6.5625C32 2.94431 28.9932 0 25.375 0H21.625V13.5132L22.0132 13.125H25.375Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.875 21.5625V25.3125C23.875 26.9438 22.5431 28.125 21.0756 28.125C15.675 28.125 10.4062 25.5719 6.4875 21.6688C2.56875 17.7656 0 12.5125 0 7.11187C0 5.56062 1.26188 4.3125 2.8125 4.3125H6.5625C6.96625 4.3125 7.32438 4.57063 7.45125 4.95312L9.32625 10.565C9.41813 10.84 9.3775 11.1413 9.2175 11.3819L7.6275 13.7675C8.23 15.0312 9.29625 16.4125 10.5275 17.6287C11.7594 18.8444 13.1562 19.895 14.42 20.4975L16.8056 18.9075C17.0475 18.7481 17.3475 18.7063 17.6225 18.7987L23.2475 20.6737C23.63 20.8006 23.875 21.1588 23.875 21.5625Z",
    fill: "#F74F22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.8777 21.5627V25.3127C23.8777 26.9439 22.5459 28.1252 21.0784 28.1252C15.6777 28.1252 10.409 25.572 6.49023 21.6689L10.5302 17.6289C11.7621 18.8445 13.159 19.8952 14.4227 20.4977L16.8084 18.9077C17.0502 18.7483 17.3502 18.7064 17.6252 18.7989L23.2502 20.6739C23.6327 20.8008 23.8777 21.1589 23.8777 21.5627Z",
    fill: "#F74F22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.875 7.5C18.3928 7.5 18.8125 7.08027 18.8125 6.5625C18.8125 6.04473 18.3928 5.625 17.875 5.625C17.3572 5.625 16.9375 6.04473 16.9375 6.5625C16.9375 7.08027 17.3572 7.5 17.875 7.5Z",
    fill: "#613D5C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.625 7.5C22.1428 7.5 22.5625 7.08027 22.5625 6.5625C22.5625 6.04473 22.1428 5.625 21.625 5.625C21.1072 5.625 20.6875 6.04473 20.6875 6.5625C20.6875 7.08027 21.1072 7.5 21.625 7.5Z",
    fill: "#613D5C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.5625 6.5625C22.5625 6.04475 22.1428 5.625 21.625 5.625V7.5C22.1428 7.5 22.5625 7.08025 22.5625 6.5625Z",
    fill: "#4B2746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.375 7.5C25.8928 7.5 26.3125 7.08027 26.3125 6.5625C26.3125 6.04473 25.8928 5.625 25.375 5.625C24.8572 5.625 24.4375 6.04473 24.4375 6.5625C24.4375 7.08027 24.8572 7.5 25.375 7.5Z",
    fill: "#4B2746"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c161050d8bbfc22b7a0fe6f48e8e3821.svg";
export { ForwardRef as ReactComponent };